import React from 'react'
import { cn } from '@/lib/utils'

class FieldRow extends React.Component {
  render() {
    return (
      <div className={cn('flex items-center py-3', !this.props.last && 'border-b')}>
        <div className="w-[180px] shrink-0 text-sm font-semibold text-foreground">{this.props.label}</div>
        <div className="relative flex-1">
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default FieldRow
